import { TColumnProps }             from './table';
import { FilterDropdownProps, Key } from 'antd/es/table/interface';
import { TableFilter }              from 'View/Common/TableFilter/TableFilter';
import { SearchOutlined }           from '@ant-design/icons';
import { InputRef }                 from 'antd';
import { RefObject }                from 'react';
import { getListDefaultState }      from '../GetListDefaultState/GetListDefaultState';
import trim                     from 'lodash/trim';

type TProps = {
  searchInput: RefObject<InputRef>,
  onSearch: ({ searchText, searchColumn }: { searchText: string, searchColumn: string }) => void,
  column: TColumnProps
}

export const searcher = ({ column, onSearch, searchInput }: TProps) => {
  if(!column.searchable || column.key === 'actions') {
    return {};
  }
  const { filter } = getListDefaultState({ page: 1, take: 10 });
  const _filter = filter.find(({ field }) => field === column.key);
  const defaultFilteredValue = _filter?.value ? [trim(_filter?.value, '%')] : undefined;

  return {
    defaultFilteredValue,
    filterDropdown: (filterProps: FilterDropdownProps) => (
      <TableFilter
        { ...filterProps }
        dataIndex={column.key}
        searchInput={searchInput}
        onSearch={onSearch}
      />
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value: boolean | Key, record: any) =>
      record[`__${column.key}`]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible: boolean) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  }
}
